import {FaSpinner} from "react-icons/fa";

const Spinner=({className})=>{

    return <div className="">
            <FaSpinner className={`animate-spin ${className}`}/>
    </div>
}
export default Spinner;